import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';
import { getDefaultState } from './utils';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: getDefaultState(),
};
